const BASE_URL = process.env.REACT_APP_API_URL ?? "";
const SESSION_MS = 12 * 60 * 60 * 1000;

async function refreshAccessToken() {
  const refresh = localStorage.getItem("refresh_token");
  if (!refresh) {
    _forceLogout();
    return null;
  }

  try {
    const res = await fetch(`${BASE_URL}/api/core/token/refresh/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refresh }),
    });

    if (!res.ok) {
      _forceLogout();
      return null;
    }

    const data = await res.json();
    localStorage.setItem("access_token", data.access);
    if (data.refresh) {
      localStorage.setItem("refresh_token", data.refresh);
    }
    return data.access;
  } catch {
    _forceLogout();
    return null;
  }
}

function _forceLogout() {
  localStorage.clear();
  window.location.href = "/login";
}

export function getAuthHeaders(extraHeaders = {}) {
  const token = localStorage.getItem("access_token");
  const lang  = localStorage.getItem("lang") || "es";
  const rol   = localStorage.getItem("rol");
  const isSuper = localStorage.getItem("is_superuser") === "true";
  const condoHeader =
    rol === "CONTADOR" || isSuper
      ? { "X-Condominio-ID": localStorage.getItem("active_condominio_id") || "" }
      : {};
  return {
    "Accept-Language": lang,
    ...condoHeader,
    ...extraHeaders,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export default async function apiFetch(path, options = {}) {
  // Reject the call immediately if the 12-hour session has expired.
  const loginAt = parseInt(localStorage.getItem("login_at") || "0", 10);
  if (loginAt && Date.now() - loginAt > SESSION_MS) {
    _forceLogout();
    return new Response(null, { status: 401 });
  }

  const access = localStorage.getItem("access_token");
  const lang   = localStorage.getItem("lang") || "es";
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;

  const makeHeaders = (token) => {
    const rol = localStorage.getItem("rol");
    const isSuper = localStorage.getItem("is_superuser") === "true";
    const condoHeader =
      rol === "CONTADOR" || isSuper
        ? { "X-Condominio-ID": localStorage.getItem("active_condominio_id") || "" }
        : {};
    return {
      // Con FormData no se fija Content-Type: el navegador arma el boundary
      // multipart automáticamente, y si lo forzamos aquí lo rompemos.
      ...(isFormData ? {} : { "Content-Type": "application/json" }),
      "Accept-Language": lang,
      ...condoHeader,
      ...(options.headers ?? {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
  };

  let res = await fetch(`${BASE_URL}${path}`, {
    ...options,
    headers: makeHeaders(access),
  });

  if (res.status === 401) {
    const newToken = await refreshAccessToken();
    if (!newToken) return res;

    res = await fetch(`${BASE_URL}${path}`, {
      ...options,
      headers: makeHeaders(newToken),
    });
  }

  return res;
}
